<template>
	<div v-if="description" class="px-5 py-5 border-bottom" >
		<p>Popis zadania</p>
		<section class="description-detail px-2 py-2 w-100 rounded mt-2" v-html="preparedDescription" />
	</div>
  
	<div v-if="inheritedDescription" class="px-5 py-5 border-bottom">
		<p>Popis mastertasku</p>
		<section class="description-detail px-2 py-2 w-100 rounded mt-2" v-html="preparedInheritedDescription" />
	</div>
</template>

<script>
import { prepareHTMLDescription } from '@/plugins/tm@_utils/server-links.utils'

export default {
	props: {
		description: {
			type: String || null,
			default: () => null
		},

		inheritedDescription: {
			type: String || null,
			default: () => null
		}
	},

	data() {
		return {
			copiedIndices: [],
			preparedDescription: '',
			preparedInheritedDescription: ''
		}
	},

	mounted() {
		this.preparedDescription = prepareHTMLDescription(this.description)
		this.preparedInheritedDescription = prepareHTMLDescription(this.inheritedDescription)
	}
}
</script>
